/**
 * Módulos dados de alta en el toast automático de errores de lectura.
 *
 * El middleware sólo actúa sobre los prefijos listados aquí, así que integrar un
 * módulo nuevo al esquema global es agregar una línea. Mientras un módulo no
 * aparezca en la lista su comportamiento actual no cambia en absoluto.
 *
 * El prefijo es el primer segmento del action type del thunk
 * ('appUsers/getUsers/rejected' -> 'appUsers'), no la llave del reducer.
 */
//El slice appBankTransactions reparte sus lecturas en varios prefijos de action type.
//appFilterBankTransactions queda fuera: ReportTransactions ya muestra su propio panel de error
const BANK_TRANSACTIONS_MODULES = [
    'appBankTransactions',
    'appBankTransactionsMovements',
    'appBankTransactionsToInvoice',
    'appReportTransactions',
    'appBankTransactionsIntermediary',
    'appAllBankTransactionsIntermediary',
    'appBankTransactionsUnidentified',
    'appBankTransactionsIdentified',
    'appBankTransactionsSBC',
    'appBankTransactionsSBCByAccount'
]

export const ERROR_TOAST_MODULES = ['appUsers', 'appRoles', 'appIntermediaries', 'appPartners', 'appGiros', 'appActivities', 'appAddress', 'appCompanies', 'appTaxRegimes', 'appBankAccounts', 'appBankTypes', ...BANK_TRANSACTIONS_MODULES, 'appBankActivities']

/**
 * Mensaje mostrado cuando el backend no manda un `detail` legible.
 * La llave es el action type sin el sufijo de estado ('appUsers/getUsers').
 * Si una operación no está aquí se usa el mensaje genérico del middleware.
 */
export const ERROR_TOAST_MESSAGES = {
    'appUsers/getUsers': 'No se pudieron cargar los usuarios.',
    'appUsers/getUsersByRole': 'No se pudieron cargar los usuarios del rol.',
    'appUsers/getUserById': 'No se pudo cargar el usuario.',
    'appRoles/getRoles': 'No se pudieron cargar los roles.',
    'appIntermediaries/getIntermediaries': 'No se pudieron cargar los intermediarios.',
    'appIntermediaries/getIntermediariesResume': 'No se pudo cargar el resumen de intermediarios.',
    'appIntermediaries/getIntermediary': 'No se pudo cargar el intermediario.',
    'appPartners/getPartners': 'No se pudieron cargar los socios.',
    'appGiros/getGiros': 'No se pudieron cargar los giros.',
    'appActivities/getActivities': 'No se pudieron cargar las actividades empresariales.',
    'appAddress/getAddress': 'No se pudieron cargar las direcciones.',
    'appCompanies/getCompanies': 'No se pudieron cargar las compañías.',
    'appCompanies/getCompaniesToTracking': 'No se pudieron cargar las compañías para seguimiento.',
    'appCompanies/getCompaniesTM': 'No se pudieron cargar las compañías del buzón tributario.',
    'appTaxRegimes/getTaxRegimes': 'No se pudieron cargar los regímenes fiscales.',
    'appBankAccounts/getBankAccounts': 'No se pudieron cargar las cuentas bancarias.',
    'appBankAccounts/getBankAccountsMXN': 'No se pudieron cargar las cuentas bancarias en MXN.',
    'appBankAccounts/getBankAccountsMXNKuspit': 'No se pudieron cargar las cuentas bancarias de Kuspit.',
    'appBankAccounts/getBankAccountsUSD': 'No se pudieron cargar las cuentas bancarias en USD.',
    'appBankAccounts/getBankAccountById': 'No se pudo cargar la cuenta bancaria.',
    'appBankAccounts/getBankAccountCheckbooks': 'No se pudieron cargar las chequeras.',
    'appBankAccounts/getBankAccountCheckBooks': 'No se pudieron cargar las chequeras.',
    'appBankTypes/getBankTypes': 'No se pudieron cargar los bancos.',
    'appBankTransactions/getBankTransactions': 'No se pudieron cargar las transacciones de la cuenta.',
    'appBankTransactions/getBankTransactionsMXNTraditional': 'No se pudieron cargar las transacciones de la cuenta.',
    'appBankTransactions/getBankTransactionsByMovement': 'No se pudieron cargar las transacciones del tipo de movimiento.',
    'appBankTransactions/getBankTransactionsToConfirm': 'No se pudieron cargar las transacciones por confirmar.',
    'appBankTransactions/getBankTransactionsToConfirmUSD': 'No se pudieron cargar las transacciones por confirmar en USD.',
    'appBankTransactionsMovements/getBankTransactionsMovements': 'No se pudieron cargar los tipos de movimiento.',
    'appBankTransactionsToInvoice/getBankTransactionsToInvoice': 'No se pudieron cargar las transacciones por facturar.',
    'appReportTransactions/getReportTransactions': 'No se pudo cargar el reporte de transacciones.',
    'appBankTransactionsIntermediary/getBankTransactionsIntermediary': 'No se pudieron cargar las transacciones del intermediario.',
    'appAllBankTransactionsIntermediary/getAllBankTransactionsIntermediary': 'No se pudieron cargar las transacciones del intermediario.',
    'appBankTransactionsUnidentified/getBankTransactionsUnidentified': 'No se pudieron cargar las transacciones no identificadas.',
    'appBankTransactionsUnidentified/getBankTransactionsUnidentifiedUSD': 'No se pudieron cargar las transacciones no identificadas en USD.',
    'appBankTransactionsIdentified/getBankTransactionsIdentified': 'No se pudieron cargar las transacciones identificadas.',
    'appBankTransactionsIdentified/getBankTransactionsIdentifiedUSD': 'No se pudieron cargar las transacciones identificadas en USD.',
    'appBankTransactionsSBC/getBankTransactionsSBC': 'No se pudieron cargar los cheques SBC.',
    'appBankTransactionsSBCByAccount/getBankTransactionsSBCByAccount': 'No se pudieron cargar los cheques SBC de la cuenta.',
    'appBankActivities/getAllBankActivities': 'No se pudieron cargar las actividades bancarias.',
    'appBankActivities/getAllBankActivitiesUSD': 'No se pudieron cargar las actividades bancarias en USD.',
    'appBankActivities/getAllBankActivitiesAssigned': 'No se pudieron cargar las actividades del usuario.',
    'appBankActivities/getBankActivitiesIntermediary': 'No se pudieron cargar las actividades bancarias del intermediario.',
    'appBankActivities/getBankActivitiesToTransfer': 'No se pudieron cargar los movimientos por transferir.',
    'appBankActivities/getBankActivitiesPending': 'No se pudieron cargar las actividades pendientes.',
    'appBankActivities/getBankActivitiesPendingUSD': 'No se pudieron cargar las actividades pendientes en USD.',
    'appBankActivities/getMyBankActivities': 'No se pudieron cargar tus actividades asignadas.',
    'appBankActivities/getMyBankActivitiesUSD': 'No se pudieron cargar tus actividades asignadas en USD.',
    'appBankActivities/getMyBankActivitiesTraditional': 'No se pudieron cargar tus actividades asignadas de Bancos Toluca.',
    'appBankActivities/getMyBankActivitiesApplied': 'No se pudieron cargar tus actividades aplicadas.',
    'appBankActivities/getMyBankActivitiesAppliedUSD': 'No se pudieron cargar tus actividades aplicadas en USD.',
    'appBankActivities/getMyBankActivitiesAppliedTraditional': 'No se pudieron cargar tus actividades aplicadas de Bancos Toluca.',
    'appBankActivities/getActivitiesTaken': 'No se pudieron cargar las actividades por usuario.',
    'appBankActivities/getActivitiesTakenUSD': 'No se pudieron cargar las actividades por usuario en USD.',
    'appBankActivities/getActivitiesLayout': 'No se pudo descargar el layout de SIPARE.',
    'appBankActivities/getLayoutTransfers': 'No se pudo descargar el layout de transferencias.'
}
